import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';
import { ToasterService } from './core/services/toaster/toaster.service';
import { DatePipe } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { RevokePayrollComponent } from './feature-module/payroll/manage-employee-salary/revoke-payroll/revoke-payroll.component';

@NgModule({
  declarations: [AppComponent, RevokePayrollComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RouterModule,
    SharedModule,
    TooltipModule.forRoot(),
  ],
  providers: [ToasterService,DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
